import {Component, inject, OnDestroy} from '@angular/core';
import {UserStateService} from "../user-service";
import {RouterOutlet} from "@angular/router";
import {watchParam} from "@utils";

@Component({
  selector: 'wun-details',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent implements OnDestroy{

  private readonly userStateService = inject(UserStateService);
  id = watchParam('id')
  constructor() {
    this.userStateService.showSideBar.set(false);
  }
  ngOnDestroy(): void {
    this.userStateService.showSideBar.set(true)
  }
}
